import faker from 'faker';

import {
  IBank,
  IBankData,
  IBankPaymentInstruction,
  IBankPaymentInstructionData,
  IBankPaymentInstructionPropertyData
} from '../bank.types';
import { Bank, BankPaymentInstruction } from '../bank';
import { createRange } from '@/utils/helpers';
import { createRandomAddress } from '@/models/address';

export function createRandomBank(): IBankData {
  return {
    id: faker.datatype.number(),
    name: faker.company.companyName(),
    address: createRandomAddress(),
    phone1: faker.phone.phoneNumber(),
    phone2: faker.phone.phoneNumber()
  };
}

export function createRandomPaymentInstruction(): IBankPaymentInstructionData {
  return {
    id: faker.datatype.number(),
    identifier: faker.datatype.string(3),
    bank: createRandomBank(),
    properties: mockPaymentInstructionPropertyData
  };
}

export function createRandomPaymentInstructionProperty(): IBankPaymentInstructionPropertyData {
  return {
    id: faker.datatype.number(),
    property: faker.random.word(),
    value: faker.random.word()
  };
}

export const mockPaymentInstructionPropertyData: IBankPaymentInstructionPropertyData[] = createRange(
  4
).map(() => createRandomPaymentInstructionProperty());

export const mockPaymentInstructionsData: IBankPaymentInstructionData[] = createRange(
  4
).map(() => createRandomPaymentInstruction());

export const mockBanksData: IBankData[] = createRange(5).map(() =>
  createRandomBank()
);

export const mockBanks = (data: IBankData[] = mockBanksData): IBank[] =>
  data.map(item => new Bank(item));

export const mockPaymentInstructions = (
  data: IBankPaymentInstructionData[] = mockPaymentInstructionsData
): IBankPaymentInstruction[] =>
  data.map(item => new BankPaymentInstruction(item));

export const mockPaginatedBank = {
  count: mockBanksData.length,
  next: null,
  previous: null,
  results: mockBanks
};
